export default "__VITE_ASSET__XDuXsF4b__"